import { Component, inject, OnInit } from '@angular/core';
import { SessionStorageService } from '../../services/session-storage.service';

@Component({
  selector: 'app-home-office-reports',
  templateUrl: './home-office-reports.component.html',
  styleUrls: ['./home-office-reports.component.scss'],
  standalone: false,
})
export class HomeOfficeReportsComponent implements OnInit {
  private ss = inject(SessionStorageService);
  rights: string[] = [];
  showPolicyReview = false;
  showPolicyTags = false;

  constructor() {}

  ngOnInit() {
    this.rights = this.ss.get('rights');
    this.showPolicyReview = this.rights.includes(
      'PMHomeOfficeTopPolicyReviewOpportunitiesGrid'
    );
    this.showPolicyTags = this.rights.includes(
      'PMHomeOfficeRepPolicyAlertsGrid'
    );
  }
}
